export var now = function () { return new Date(); };
export var isTimePastThreshold = function (thresholdInMilliseconds) { return function (timeInSecondsSinceEpoch) {
    var givenTimeMs = timeInSecondsSinceEpoch * 1000;
    var currentTimeMs = now().getTime();
    return givenTimeMs - currentTimeMs < thresholdInMilliseconds;
}; };
export var isTimeInPast = isTimePastThreshold(0);
